import type { PostgrestResponse } from "@supabase/postgrest-js";
import type { GetAllOptions } from "../../../server/supabase/base-supabase-service";
import { SupabaseService } from "../../../server/supabase/base-supabase-service";
import type { UUID } from "../../../utils/uuid";
import type { WhatsAppMoment, WhatsAppTemplate } from "../types";

export const normaliseWhatsAppMomentForSave = (moment: WhatsAppMoment): WhatsAppMoment => ({
  ...moment,
  digital_asset_id: moment.destination_type === "content_library" ? moment.digital_asset_id : null,
  url: moment.destination_type === "url" ? (moment.url?.trim() ?? null) : null,
});

export class SupabaseWhatsAppMomentService extends SupabaseService<"whatsapp_moment"> {
  table = "whatsapp_moment" as const;
}

export class SupabaseWhatsAppTemplateService extends SupabaseService<"whatsapp_template"> {
  table = "whatsapp_template" as const;

  async getActive(accountId: UUID): Promise<PostgrestResponse<WhatsAppTemplate>> {
    return this.getAll(accountId, {
      filter: [{ key: "deleted_at", operator: "is", value: null }],
      order: [{ column: "name", dir: "asc" }],
    } satisfies GetAllOptions<WhatsAppTemplate>);
  }
}
